import { getDefaultMaterialDuration } from "@common/chapters/materialDuration"
import { useCallback, useEffect, useRef } from "react"

/**
 * The form's duration follows the class's default (`getDefaultMaterialDuration`)
 * until the tutor picks one in the Durée field; after that, a class change (the
 * analyse correcting it, a program chapter, a manual pick) never takes their
 * choice back — it used to: a 15 min pick fell back to 5 min on its own.
 *
 * The pick is told by the Durée field itself (`onDurationPicked`), not read off
 * react-hook-form's `watch` events: their `type: "change"` sticks to the form
 * state after the first edit of any field and then tags later `setValue`s too.
 */
export const useClassDefaultDuration = ({ watchedClass, setValue }) => {
    const pickedRef = useRef(false)

    useEffect(() => {
        if (watchedClass && !pickedRef.current) {
            setValue("selectedDuration", getDefaultMaterialDuration(watchedClass))
        }
    }, [watchedClass])

    const onDurationPicked = useCallback(() => {
        pickedRef.current = true
    }, [])
    // A new generation starts from the class's default again.
    const forgetPickedDuration = useCallback(() => {
        pickedRef.current = false
    }, [])

    return { onDurationPicked, forgetPickedDuration }
}
